
import SectionTitle from '../../../shared/SectionTitle'
import MenuRowItem from '../../../shared/MenuRowItem'

export default {
  name: 'RateExamSection',
  components: { SectionTitle, MenuRowItem },
}
